import { render, staticRenderFns } from "./JdsNavigatorChildItem.vue?vue&type=template&id=ab277084&scoped=true&"
import script from "./JdsNavigatorChildItem.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorChildItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab277084",
  null
  
)

export default component.exports